// Marketing site is served as static HTML from public/index.html.
// This React app renders nothing — kept only for the CRA dev-server pipeline.
function App() {
  return null;
}

export default App;
